import React from 'react'
import { Button, Dialog, DialogActions, DialogContent, DialogTitle, Divider, TextField } from '@mui/material'

export default function TermsConditions({ open, setOpen }) {
  const handleClose = () => {
    setOpen(false);
  };

  return (
    <Dialog open={open} onClose={handleClose}>
      <DialogTitle>TERMS & CONDITIONS FOR SOLA SYSTEM ERP SOFTWARE</DialogTitle>
      <Divider />
      <DialogContent>
        <p className="last-updated">Last Updated: [16.09.2024]</p>

        <p>Welcome to SOLA SYSTEM, a web-based ERP software provided by Apertech MMC. By accessing or using our
          software, you agree to comply with and be bound by the following terms and conditions. Please read them
          carefully before using the software.</p>

        <h2>1. Acceptance of Terms</h2>
        <p>By using SOLA SYSTEM, you agree to these Terms & Conditions. If you do not agree with any part of these
          terms, you may not use the software.</p>

        <h2>2. License Grant</h2>
        <p>Apertech MMC grants you a non-exclusive, non-transferable, limited license to use SOLA SYSTEM in accordance
          with the terms of this agreement. This license is subject to the payment of applicable fees and compliance
          with these terms.</p>

        <h2>3. User Obligations</h2>
        <ul>
          <li>Users must provide accurate and up-to-date information during the registration process.</li>
          <li>You are responsible for maintaining the confidentiality of your login credentials and for all activities
            that occur under your account.
          </li>
          <li>You agree not to use SOLA SYSTEM for any illegal or unauthorized purpose, including, but not limited to,
            violating any intellectual property or privacy rights.
          </li>
        </ul>

        <h2>4. Restrictions</h2>
        <ul>
          <li>You may not reverse engineer, decompile, or disassemble the software.</li>
          <li>You are prohibited from sharing, sublicensing, or distributing the software to third parties.</li>
          <li>Modification or creation of derivative works based on SOLA SYSTEM is not allowed.</li>
        </ul>

        <h2>5. Data Privacy and Security</h2>
        <ul>
          <li>Apertech MMC is committed to protecting your privacy. All personal and business data you provide while
            using SOLA SYSTEM will be handled in accordance with our Privacy Policy.
          </li>
          <li>We implement industry-standard security measures to protect your data, but we cannot guarantee absolute
            security. You acknowledge and agree that data transmission over the internet carries inherent risks.
          </li>
        </ul>

        <h2>6. Intellectual Property</h2>
        <ul>
          <li>SOLA SYSTEM and all its components, including but not limited to software code, design, and trademarks,
            are the intellectual property of Apertech MMC.
          </li>
          <li>You are granted a license to use the software; this does not transfer any ownership rights to you.</li>
        </ul>

        <h2>7. Limitation of Liability</h2>
        <ul>
          <li>Apertech MMC is not liable for any direct, indirect, incidental, special, or consequential damages arising
            from the use or inability to use SOLA SYSTEM.
          </li>
        </ul>

        <h2>8. Support and Maintenance</h2>
        <ul>
          <li>Apertech MMC will provide technical support and maintenance services as outlined in your service
            agreement.
          </li>
          <li>Updates and enhancements to SOLA SYSTEM will be provided at Apertech MMC's discretion and may be subject
            to
            additional fees.
          </li>
        </ul>

        <h2>9. Amendments</h2>
        <ul>
          <li>Apertech MMC reserves the right to modify these Terms & Conditions at any time. Any changes will be
            effective immediately upon posting. Your continued use of SOLA SYSTEM after such modifications constitutes
            your acceptance of the new terms.
          </li>
        </ul>

        <h2>10. Contact Information</h2>
        <p className="last-updated">If you have any questions about these Terms & Conditions, please contact us at:</p>

        <ul>
          <li>Email: info@apertech.net
          </li>
          <li>Address: Narimanov d. Dernegul Business Center (Chinar Park), Ziya Bunyadov av 1965, Building 4A, 6th floor, Room #47, Baku, Azerbaijan
          </li>

        </ul>

      </DialogContent>
      <DialogActions>

        <Button variant="outlined" onClick={handleClose}>
          Close
        </Button>
      </DialogActions>
    </Dialog>
  );
}